/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UpdateLearningDomainStatusRequest interface.
 */
export function instanceOfUpdateLearningDomainStatusRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "visibility" in value;
    isInstance = isInstance && "availability" in value;
    return isInstance;
}
export function UpdateLearningDomainStatusRequestFromJSON(json) {
    return UpdateLearningDomainStatusRequestFromJSONTyped(json, false);
}
export function UpdateLearningDomainStatusRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'visibility': json['visibility'],
        'availability': json['availability'],
        'isInFreePromotion': !exists(json, 'isInFreePromotion') ? undefined : json['isInFreePromotion'],
    };
}
export function UpdateLearningDomainStatusRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'visibility': value.visibility,
        'availability': value.availability,
        'isInFreePromotion': value.isInFreePromotion,
    };
}
